import gql from 'graphql-tag';

export default gql`
    mutation EndStages($input: EndStagesInput) {
        endStages(input: $input) {
            errors
        }
    }
`;
